module.exports = __webpack_public_path__ + "static/img/13.b34db24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/13.png
// module id = m7aY
// module chunks = 0